import { render, staticRenderFns } from "./feld-label.vue?vue&type=template&id=168429dc&scoped=true"
import script from "./feld-label.vue?vue&type=script&lang=js"
export * from "./feld-label.vue?vue&type=script&lang=js"
import style0 from "./feld-label.vue?vue&type=style&index=0&id=168429dc&prod&scoped=true&lang=css"
import style1 from "./feld-label.vue?vue&type=style&index=1&id=168429dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168429dc",
  null
  
)

export default component.exports